import type { MangaItem } from "@/mocks/manga";

interface Props {
  manga: MangaItem;
  compact?: boolean;
}

export default function MangaCard({ manga, compact }: Props) {
  return (
    <article className="group rounded-lg overflow-hidden bg-background-100 border border-background-300/40 hover:border-primary-500/50 transition-colors flex flex-col h-full">
      <div className="relative overflow-hidden aspect-[3/4]">
        <img
          src={manga.cover}
          alt={`${manga.title} 暗黑猎奇漫画封面`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-950/90 via-background-950/10 to-transparent"></div>
        <span className="absolute top-2.5 left-2.5 px-2 py-0.5 rounded bg-primary-600/90 text-foreground-950 text-xs font-medium">
          {manga.rating.toFixed(1)}
        </span>
        <span className="absolute top-2.5 right-2.5 px-2 py-0.5 rounded bg-background-950/70 text-foreground-500 text-xs">
          {manga.status}
        </span>
        <div className="absolute bottom-2.5 left-2.5 right-2.5 flex items-center justify-between">
          <span className="text-xs text-foreground-300">
            <i className="ri-time-line mr-1"></i>
            {manga.chapter}
          </span>
          <span className="text-xs text-foreground-400">
            <i className="ri-eye-line mr-1"></i>
            {manga.views}
          </span>
        </div>
      </div>

      <div className="p-3.5 flex flex-col flex-1">
        <h3 className="font-heading text-base font-bold text-foreground-950 mb-1.5 truncate">
          {manga.title}
        </h3>
        <p className={`text-xs leading-relaxed text-foreground-500 ${compact ? "line-clamp-2" : "line-clamp-2"}`}>
          {manga.desc}
        </p>
        <div className={`flex flex-wrap gap-1.5 mt-auto ${compact ? "pt-3" : "pt-3"}`}>
          {manga.tags.map((tag) => (
            <span
              key={tag}
              className="px-2 py-0.5 rounded bg-secondary-200/40 text-secondary-300 text-[11px]"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </article>
  );
}